<template>
  <main>
    <hero :heading="entry.title" :subheading="entry.hero.subheading" :images="entry.heroImages" position="bottom" />
    <div class="c-section">
      <div class="o-wrapper o-wrapper--small o-box-off">
        <div class="o-box-off u-ff-alt u-mb u-mb+@tablet u-pb" v-html="entry.body"></div>
        <div class="u-mb" v-for="entry in activeProjects" :key="entry.id">
          <project-active-card :heading="entry.title" :image="entry.image" :body="entry.summary" :slug="entry.slug" />
        </div>
      </div>
    </div>
    <div class="c-section c-section--white" v-if="archivedProjects">
      <div class="o-wrapper">
        <div class="c-section__header">
          <h2 class="c-section__heading">Archive</h2>
        </div>
        <div class="c-toolbar">
          <div class="c-toolbar__items">
            <div class="c-toolbar__item">
              <div class="c-toolbar__heading">Sort</div>
              <div class="c-toolbar-select">
                <select class="c-toolbar-select__select" v-model="archivedProjectsOrder" @change="resizeSelect" style="width:50px">
                  <option value="title">Title</option>
                  <option value="projectStartDate desc">Latest</option>
                </select>
              </div>
            </div>
            <div class="c-toolbar__item c-toolbar__item--right">
              <input class="c-toolbar-input" placeholder="Search" v-model="archivedProjectsSearchQuery">
            </div>
          </div>
        </div>
        <ul class="o-layout o-layout--large o-layout--lined-2" v-if="archivedProjects.length > 0">
          <li class="o-layout__item u-1/2@tablet u-mb+" v-for="entry in archivedProjects" :key="entry.id">
            <project-archive-card :entry="entry" />
          </li>
        </ul>
        <p v-else>Sorry, we can't find any projects.</p>
      </div>
    </div>
    <banner />
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'
import Banner from '@/components/Banner.vue'
import ProjectActiveCard from '@/components/ProjectActiveCard.vue'
import ProjectArchiveCard from '@/components/ProjectArchiveCard.vue'

export default {
  name: 'Projects',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    Banner: Banner,
    ProjectActiveCard: ProjectActiveCard,
    ProjectArchiveCard: ProjectArchiveCard
  },
  data () {
    return {
      title: null,
      entry: null,
      activeProjects: null,
      archivedProjects: null,
      archivedProjectsOrder: 'title',
      archivedProjectsSearchQuery: ''
    }
  },
  mounted () {
    this.getEntry()
    this.getArchivedProjects()
    axios
      .get('api/activeProjects.json')
      .then(response => (this.activeProjects = response.data.data))
  },
  watch: {
    archivedProjectsOrder: function () {
      this.getArchivedProjects()
    },
    archivedProjectsSearchQuery: function () {
      this.getArchivedProjects()
    }
  },
  methods: {
    resizeSelect (event) {
      let elem = event.target
      let selectedText = elem.options[elem.selectedIndex].text
      elem.style.width = 20 + (selectedText.length * 8) + 'px'
    },
    getEntry () {
      axios
        .get('api/projectsIndex.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    },
    getArchivedProjects () {
      axios
        .get('api/archivedProjects.json?q=' + this.archivedProjectsSearchQuery + '&order=' + this.archivedProjectsOrder)
        .then(response => (this.archivedProjects = response.data.data))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects.vue